import { sessionExpired } from '../ducks/session';
import { setError } from '../ducks/error';
import { toastr } from 'react-redux-toastr';

const toastrOptions = {
    timeOut: 0,
    icon: 'error',
    showCloseButton: true,
    removeOnHover: false,
};

export const handleApiError = (error, dispatch, action) => {
    if (error.expired) {
        dispatch(sessionExpired());
    } else if (error.noaccess) {
        toastr.error('Access denied', error.message, toastrOptions);
        dispatch(setError(error));
    } else if (error.fatal) {
        toastr.error('Fatal error', error.message, toastrOptions);
        dispatch(setError(error));
    }

    if (action && action.message && !error.fatal && !error.noaccess) {
        toastr.error('Error', action.message, toastrOptions);
    } else if (!action && !error.fatal && !error.noaccess) {
        toastr.error('Error', error.message, toastrOptions);
    }

    return action ? dispatch(action) : Function.prototype;
};

export const handleError = (message = 'A general error occurred...') => {
    throw new Error(message);
};

export const handleFatalError = (
    status = 'N/A',
    statusText = '',
    message = 'A fatal error occurred...'
) => {
    const error = new Error(message);
    error.fatal = true;
    error.status = status;
    error.statusText = statusText;
    error.description = message;
    throw error;
};

export const handleSessionExpiredError = (
    message = 'Your session has expired... Please log in again to continue.'
) => {
    const error = new Error(message);
    error.expired = true;
    throw error;
};

export const handleNoAccessError = (
    message = 'Sorry, but you do not have the required access rights to perform this action.'
) => {
    const error = new Error(message);
    error.noaccess = true;
    throw error;
};
